import { render, staticRenderFns } from "./PastAwardsPhotoAlbum.vue?vue&type=template&id=22a4777a&scoped=true"
import script from "./PastAwardsPhotoAlbum.vue?vue&type=script&lang=js"
export * from "./PastAwardsPhotoAlbum.vue?vue&type=script&lang=js"
import style0 from "./PastAwardsPhotoAlbum.vue?vue&type=style&index=0&id=22a4777a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a4777a",
  null
  
)

/* custom blocks */
import block0 from "./PastAwardsPhotoAlbum.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports